export const languages = {
    langData: [
        {
            id:1,
            val: 'trilingual',
            lng: 'Abax Default',
            desc: 'This model is customised for Singapore English Mandarin Malay'
        }
    ]
}
